import React from 'react';
import { useOrderData } from './hooks/useAddLinkData';
import { Recipients } from '../basicorderinfo/Types';
import { AuthenticatedUser } from '../../../../shared/types';
import { isBrokerAgent } from '../../utils/brokerAgentUtils';
import MatterportAdmin from './view/MatterportAdmin';
import { useTelemetryContext } from '../../../../telemetry/telemetryContext';
import { getUserInfo } from '../../../../telemetry/utils';
import MatterportBroker from './view/MatterportBroker';
import { MatterportInProgress } from "./view/MatterportInProgress";

type MatterportLabels = {
    // ...
};

type MatterportProps = {
    orderId: number;
    labels: MatterportLabels;
    addedLink: string | null;
    brokerAgentEmail: string;
    createMail: (recipient: Recipients) => void;
    user: AuthenticatedUser;
};

function isEmpty(value: string | null): boolean {
    return value === null || value.length === 0;
}
    

const MatterportHandling = ({ orderId, addedLink, brokerAgentEmail, user }: MatterportProps) => {
    if (isBrokerAgent(user.details.role)) {
        return isEmpty(addedLink) ? <MatterportInProgress /> : <MatterportBroker link={addedLink} />;
    }

    return (
        <MatterportAdmin
            orderId={orderId}
            user={user}
            addedLink={addedLink}
            brokerAgentEmail={brokerAgentEmail}
        />
    );
};

function DataLayer(props) {
    let { isError, isLoading, data, error } = useOrderData(props.orderId);
    let { logger } = useTelemetryContext();

    if (isError) {
        let additionalInfo = {
            origin: 'MatterportHandling.DataLayer',
            userInfo: getUserInfo(props.user)
        };

        logger.logException(error, additionalInfo);
    }
    
    if (isLoading) {
        return null;
    }

    return <MatterportHandling {...props} addedLink={data ? data.matterportLink : null} />;
}

export default DataLayer;
